import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class GoogleConfigService {

    constructor(private http: HttpClient) { }

    createGoogleConfig(body: any): Observable<any> {
        return this.http.post(environment.createGoogleConfig, body);
    }

    updateGoogleConfig(body: any): Observable<any> {
        return this.http.put(environment.updateGoogleConfig, body);
    }

    getAllGoogleTokenConfigByClientId(body: any): Observable<any> {
        return this.http.post(environment.getGoogleConfigByClientId, body);
    }

    deleteGoogleConfig(body: any): Observable<any> {
        return this.http.post(environment.deleteGoogleConfig,  body);
    }

    
}
